module.exports = __webpack_public_path__ + "media/images/hitfun/sample.userpic80x80-fa5479cb67fdd244f14cde3b9704977e.jpg";